import { render, staticRenderFns } from "./EhubPrefillNotification.vue?vue&type=template&id=131e85fa&scoped=true&"
import script from "./EhubPrefillNotification.vue?vue&type=script&lang=js&"
export * from "./EhubPrefillNotification.vue?vue&type=script&lang=js&"
import style0 from "./EhubPrefillNotification.vue?vue&type=style&index=0&id=131e85fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e85fa",
  null
  
)

export default component.exports